import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, withStyles } from '@material-ui/core';
import { connect } from 'react-redux';

const styles = theme => ({
    buttonDanger: {
        color: theme.palette.buttonText.default,
        backgroundColor: theme.palette.error.dark,
        borderRadius: '1px'
    },
    buttonSafe: {
        color: theme.palette.buttonText.default,
        backgroundColor: theme.palette.success.dark,
        borderRadius: '1px'
    }
});

const ErasureReportRegenerate = props => {
    let { classes, regenerateModalState, entityName, translations, handleCloseSafe, handleCloseDanger, diagnose } = props;

    return (
        <Dialog
            open={regenerateModalState.open}
            onClose={handleCloseSafe}
            aria-labelledby="form-dialog-title"
            disableBackdropClick={true}
            disableEscapeKeyDown={false}
            fullWidth={true}
        >
            <DialogTitle id="form-dialog-title">{translations['regenerate'] || 'Regenerate'} {entityName.toLowerCase()}</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    {diagnose? translations['diagnose_report_warning'] || 'Diagnose report is already being generated' : translations['erasure_report_warning'] || 'An erasure report is already being generated'}.<br />
                    {translations['sure_want_regenerate'] || `Are you sure you want to regenerate`}{' '}{translations['this'] ? translations['this'].toLowerCase() : 'this'.toLowerCase()}{` ${entityName.toLowerCase()}`}?
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCloseSafe} variant="contained" className={classes.buttonSafe}>
                    {translations['no'] || 'No'}
                </Button>
                <Button onClick={() => handleCloseDanger()} variant="contained" className={classes.buttonDanger}>
                    {translations['yes'] || 'Yes'}
                </Button>
            </DialogActions>
        </Dialog>
    );
}

const mapStateToProps = state => {
    return {
        translations: state?.translate?.translations?.activeTranslations ?? {},
    };
};

export default connect(
    mapStateToProps,
    null
)(withStyles(styles)(ErasureReportRegenerate));